var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFinish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.0139,
    y1: 223.4287,
    x2: 484.3639,
    y2: 185.9087,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M423.478,447.24c-75.494-6.665-146.363-29.888-211.219-69.217 c-9.67-5.864-14.037-17.615-10.538-28.37l77.492-238.233c66.113,43.57,138.804,69.9,216.532,78.486 c14.057,1.553,21.087,17.784,12.534,29.047c-17.41,22.924-34.93,45.761-52.561,68.515c-14.235,18.372-21.055,41.416-19.125,64.577 c2.098,25.167,4.266,50.329,6.497,75.484C444.087,438.766,434.714,448.232,423.478,447.24z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.4403,
    y1: 148.7784,
    x2: 315.2703,
    y2: 157.6084,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M240.542,291.073c-9.67-5.864-14.037-17.615-10.538-28.37l-28.282,86.949 c-3.499,10.755,0.868,22.505,10.538,28.37c42.983,26.066,88.608,45.049,136.469,56.833l28.282-86.949 C329.151,336.121,283.524,317.139,240.542,291.073z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.9029,
    y1: 313.1557,
    x2: 368.7329,
    y2: 321.9957,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M270.417,199.225c40.151,24.349,88.165,44.316,136.283,57.406l25.373-78.005 c0.001,0,0.002,0,0.002,0c-53.994-13.295-105.143-35.757-152.863-67.207l-19.332,59.435 C256.381,181.61,260.748,193.36,270.417,199.225z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.7468,
    y1: 113.2477,
    x2: 449.9668,
    y2: 100.1677,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#654E48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M437.164,358.786c-20.411-2.4-40.471-6.033-60.153-10.88l-28.282,86.949 c24.356,5.997,49.289,10.137,74.75,12.384c11.236,0.992,20.608-8.474,19.612-19.71C441.058,404.62,439.086,381.705,437.164,358.786z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.1069,
    y1: 224.6181,
    x2: 339.937,
    y2: 233.4581,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M436.593,352.045c-1.931-23.161,4.889-46.205,19.125-64.577 c4.588-5.921,9.148-11.863,13.72-17.796c-20.496-2.879-41.625-7.298-62.737-13.042l-29.69,91.276 c19.683,4.847,39.742,8.479,60.153,10.88C436.976,356.539,436.78,354.292,436.593,352.045z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.8795,
    y1: 114.2233,
    x2: 263.2395,
    y2: 311.8633,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FC7E2",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M390.818,166.49c-38.929-13.366-76.211-31.744-111.605-55.07l-77.492,238.233 c-3.499,10.755,0.868,22.505,10.538,28.37c64.855,39.331,135.725,62.552,211.219,69.217c11.236,0.992,20.609-8.474,19.612-19.71 c-2.232-25.156-4.399-50.318-6.497-75.484c-1.839-22.063,4.279-44.011,17.167-61.925L390.818,166.49z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.2856,
    y1: 252.484,
    x2: 401.4256,
    y2: 228.044,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#654E48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M270.417,199.225c-9.67-5.864-14.037-17.615-10.538-28.37l-29.876,91.848 c-3.499,10.755,0.867,22.505,10.538,28.37c42.983,26.066,88.608,45.049,136.469,56.833l29.69-91.276 C358.583,243.54,310.569,223.573,270.417,199.225z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 466.2032,
    y1: 286.8466,
    x2: 506.4232,
    y2: 273.7666,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#654E48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M508.278,218.953c8.553-11.262,1.522-27.494-12.534-29.047 c-21.624-2.388-42.858-6.155-63.671-11.28l-25.373,78.005c21.112,5.743,42.24,10.163,62.737,13.042 C482.438,252.808,495.399,235.912,508.278,218.953z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.0485,
    y1: 159.4128,
    x2: 284.3185,
    y2: 312.0828,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3E2E28",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "M406.698,256.633l-29.689,91.272c-47.855-11.786-93.488-30.764-136.47-56.838 c-9.67-5.863-14.032-17.613-10.534-28.364l29.875-91.845c-3.497,10.751,0.864,22.501,10.534,28.364 C310.573,223.572,358.582,243.537,406.698,256.633z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.1919,
    y1: 203.2794,
    x2: 370.4619,
    y2: 355.9494,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3E2E28",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "M440.839,264.752c-11.323-2.298-22.734-5.022-34.141-8.12l11.701-35.973L440.839,264.752z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.8931,
    y1: 103.0713,
    x2: 278.0931,
    y2: 208.2413,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    d: "M325.847,361.249c0,0-29.817-23.279-111.65-49.952l-12.476,38.355 c-3.512,10.795,0.926,22.543,10.634,28.427c20.912,12.675,42.449,23.672,64.564,32.981c15.472,6.513,33.21-1.487,38.402-17.451 L325.847,361.249z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.7264,
    y1: 305.4565,
    x2: 371.1864,
    y2: 266.9265,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M305.08,362.116c-70.816-42.812-148.793-66.442-232.121-70.299 c27.783-85.411,55.564-170.822,83.347-256.233c75.81,3.51,147.19,23.383,212.778,59.179c21.401,11.68,31.417,36.977,23.875,60.162 c-18.332,56.357-76.958,236.592-76.958,236.592l0,0C319.628,380.371,315.11,368.179,305.08,362.116z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.5052,
    y1: 310.9326,
    x2: 372.9651,
    y2: 272.4026,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    d: "M347.387,161.468c-10.786-5.886-21.731-11.333-32.824-16.357l-29.067,89.359 c11.093,5.024,22.038,10.47,32.824,16.357c21.401,11.68,31.417,36.977,23.875,60.162c11.767-36.175,22.783-70.043,29.067-89.359 C378.804,198.445,368.788,173.147,347.387,161.468z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.9751,
    y1: 339.6324,
    x2: 302.4751,
    y2: 325.8123,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    d: "M225.583,114.847l-29.067,89.359c30.598,7.171,60.292,17.273,88.98,30.264l29.067-89.359 C285.874,132.12,256.181,122.018,225.583,114.847z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.0166,
    y1: 333.177,
    x2: 350.3866,
    y2: 301.507,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_15_)"
    },
    d: "M134.608,102.289c-9.689,29.786-19.378,59.573-29.067,89.359 c31.103,1.44,61.458,5.639,90.975,12.558l29.067-89.359C196.066,107.929,165.71,103.729,134.608,102.289z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.8855,
    y1: 246.6736,
    x2: 322.2555,
    y2: 215.0036,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_16_)"
    },
    d: "M196.517,204.206l-32.581,100.165c30.595,7.17,60.291,17.269,88.983,30.254l32.578-100.155 C256.808,221.479,227.114,211.377,196.517,204.206z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.865,
    y1: 418.792,
    x2: 378.235,
    y2: 387.122,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_17_)"
    },
    d: "M314.563,145.112l21.697-66.704c-28.686-13.004-58.382-23.103-88.98-30.264l-21.697,66.703 C256.181,122.018,285.874,132.12,314.563,145.112z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.7081,
    y1: 216.6577,
    x2: 61.5221,
    y2: 464.4977,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FC7E2",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_18_)"
    },
    d: "M316.001,391.517c0-0.001,4.924-15.138,12.357-37.989L166.794,36.188 c-3.488-0.232-6.982-0.442-10.49-0.604c-27.783,85.411-55.564,170.822-83.347,256.233c83.328,3.857,161.305,27.486,232.121,70.299 C315.11,368.179,319.628,380.371,316.001,391.517z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.9123,
    y1: 408.1212,
    x2: 105.7222,
    y2: 303.9412,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#654E48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_19_)"
    },
    d: "M134.608,102.289c31.102,1.44,61.458,5.64,90.975,12.558l21.697-66.703 c-29.517-6.916-59.874-11.12-90.979-12.561L72.953,291.82c31.106,1.441,61.465,5.635,90.982,12.551l32.581-100.165 c-29.517-6.918-59.873-11.117-90.975-12.558C115.23,161.861,124.919,132.075,134.608,102.289z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.1437,
    y1: 412.978,
    x2: 381.8037,
    y2: 355.528,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#654E48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_20_)"
    },
    d: "M371.288,221.54c8.858-27.232,16.726-51.423,21.668-66.612 c7.543-23.192-2.475-48.487-23.871-60.162c-10.788-5.893-21.731-11.342-32.825-16.359l-21.697,66.704 c11.093,5.024,22.038,10.47,32.824,16.357C368.76,173.132,378.776,198.38,371.288,221.54z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.3257,
    y1: 250.5942,
    x2: 328.9857,
    y2: 193.1442,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#654E48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_21_)"
    },
    d: "M318.32,250.827c-10.786-5.886-21.731-11.333-32.824-16.357l-32.578,100.155 c17.782,8.061,35.176,17.22,52.165,27.492c5.006,3.035,8.646,7.592,10.573,12.793c1.937,5.205,2.156,11.033,0.343,16.608 c0,0,11.67-35.875,26.223-80.619C349.71,287.739,339.694,262.491,318.32,250.827z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.8156,
    y1: 362.7738,
    x2: 365.4756,
    y2: 305.3238,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#654E48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_22_)"
    },
    d: "M225.583,114.847l-29.067,89.359c30.598,7.171,60.292,17.273,88.98,30.264l29.067-89.359 C285.874,132.12,256.181,122.018,225.583,114.847z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.9363,
    y1: 119.5267,
    x2: 134.9462,
    y2: 474.9907,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3E2E28",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_23_)"
    },
    d: "M204.583,110.426c-22.858-4.32-46.198-7.038-69.974-8.141l21.697-66.702 c1.949,0.09,3.881,0.19,5.822,0.303c1.556,0.105,3.115,0.199,4.671,0.304l0.008,0.015L204.583,110.426z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.9302,
    y1: 119.5236,
    x2: 134.9402,
    y2: 474.9896,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3E2E28",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_24_)"
    },
    d: "M328.353,353.53l-12.354,37.98c1.472-4.524,1.604-9.225,0.566-13.621 c-0.157-0.672-0.352-1.342-0.563-2.006c-0.103-0.318-0.215-0.652-0.341-0.977c-0.722-1.954-1.684-3.805-2.87-5.523 c-0.393-0.58-0.817-1.144-1.264-1.678c-0.224-0.267-0.447-0.533-0.683-0.803c-0.702-0.784-1.454-1.533-2.271-2.238 c-1.068-0.93-2.237-1.788-3.49-2.544c-2.343-1.422-4.697-2.808-7.055-4.182c-2.658-1.563-5.333-3.079-8.022-4.587 c-0.32-0.169-0.648-0.353-0.976-0.537c-1.838-1.025-3.68-2.038-5.531-3.027c-1.034-0.556-2.068-1.112-3.118-1.66 c-1.034-0.556-2.072-1.1-3.122-1.648c-1.038-0.544-2.091-1.081-3.145-1.617c-0.675-0.348-1.373-0.706-2.06-1.058 c-0.854-0.433-1.721-0.87-2.591-1.295c-0.968-0.483-1.947-0.97-2.929-1.445c-1.67-0.827-3.355-1.647-5.037-2.44 c-2.114-1.011-4.237-1.999-6.362-2.975c-0.741-0.344-1.471-0.686-2.216-1.018l25.655-78.871L328.353,353.53z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.894,
    y1: 121.5456,
    x2: 138.904,
    y2: 477.0066,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3E2E28",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_25_)"
    },
    d: "M262.883,224.918c-21.59-8.496-43.736-15.402-66.364-20.708l21.761-66.9L262.883,224.918z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.386,
    y1: 251.8453,
    x2: 362.9761,
    y2: 246.7753,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_26_)"
    },
    d: "M371.262,221.63c0.01-0.029,0.017-0.059,0.027-0.088 c-9.345,28.729-19.791,60.844-29.067,89.359c-0.009,0.029-0.017,0.059-0.027,0.088C353.963,274.814,364.979,240.945,371.262,221.63z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.6347,
    y1: 313.5411,
    x2: 344.0047,
    y2: 281.8711,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_27_)"
    },
    d: "M347.387,161.468c-10.786-5.886-21.731-11.333-32.824-16.357l-29.067,89.359 c11.093,5.024,22.038,10.47,32.824,16.357c21.374,11.665,31.39,36.912,23.902,60.073c9.275-28.515,19.721-60.63,29.067-89.359 C378.776,198.38,368.76,173.132,347.387,161.468z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.8791,
    y1: 261.2347,
    x2: 93.5491,
    y2: 256.4648,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#FFBF5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_28_)"
    },
    d: "M6.37,496.516c-4.842-1.575-7.49-6.776-5.915-11.619L151.219,21.4 c1.575-4.843,6.777-7.49,11.619-5.915c4.842,1.575,7.49,6.776,5.915,11.619L17.989,490.6 C16.414,495.442,11.212,498.091,6.37,496.516z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinish);
export default __webpack_public_path__ + "static/media/icon_finish.e1b0e9dcda4d1a766f747f934409a281.svg";
export { ForwardRef as ReactComponent };